<template>
  <v-app id="v-app">
      <v-form
        ref="form"
        v-model="validForm"
        class="flex flex-wrap">
        <div class="w-full lg:w-1/3 lg:px-2">
        <v-text-field
                :label="trans[lang].name"
                color="white"
                v-model="name"
                :rules="formRules"
                filled
                rounded
                autocomplete="off"
            ></v-text-field>
        </div>
        <div class="w-full lg:w-1/3 lg:px-2">
        <v-text-field
                :label="trans[lang].phone"
                color="white"
                v-model="phone"
                :rules="phoneRules"
                filled
                rounded
                autocomplete="off"
            ></v-text-field>
        </div>
        <div class="w-full lg:w-1/3 lg:px-2">
            <v-text-field
                    label="Email*"
                    color="white"
                    v-model="email"
                    :rules="emailRules"
                    filled
                    rounded
                    autocomplete="off"
                ></v-text-field>
        </div>
        <div class="w-full lg:px-2">
            <province-school-component></province-school-component>
        </div>
        <div class="w-full lg:px-2">
        <v-textarea
                :label="trans[lang].message"
                color="white"
                v-model="text"
                :rules="messageRules"
                filled
                rounded
            ></v-textarea>
        </div>
        <div class="flex justify-end">
            <v-btn
                type="submit"
                color="primary"
                class="contactButton"
                large
                :loading="loading"
                @click="validateAndSend"
            >Contactar</v-btn>
        </div>
      </v-form>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarType"
            content-class="text-center"
            >
            {{ snackbarText }}
        </v-snackbar>
  </v-app>
</template>

<script>
import ProvinceSchoolComponent from './ProvinceSchoolComponent';
import {mapGetters, mapMutations} from 'vuex';

const trans = {
    ca: {
        name: 'Nom i cognoms*',
        phone: 'Telèfon mòbil*',
        message: 'Missatge',
        sent: 'Missatge enviat correctament!',
        close: 'Tancar',
        formRules: '* Nom obligatori',
        pleaseRecheck: 'Sisplau, comprova que hagis emplenat tots els camps correctament.',
        error: "S'ha produït un error. Sisplau, intenta-ho de nou.",
        phoneRules: [
            '* Telèfon obligatori',
            '* El telèfon ha de ser vàlid'
        ],
        emailRules: [
            '* Email obligatori',
            "* L'email ha de ser vàlid"
        ],
        messageRules: [
            '* Missatge obligatori',
            '* La longitud mínima del missatge és de 12 caràcters'
        ]
    },
    es: {
        name: 'Nombre y apellidos*',
        phone: 'Teléfono móvil*',
        message: 'Mensaje',
        sent: 'Mensaje enviado correctamente!',
        close: 'Cerrar',
        formRules: '* Nombre obligatorio',
        pleaseRecheck: 'Por favor, comprueba que hayas rellenado todos los campos correctamente.',
        error: 'Se ha producido un error. Por favor, inténtalo de nuevo.',
        phoneRules: [
            '* Teléfono obligatorio',
            '* El teléfono debe ser válido'
        ],
        emailRules: [
            '* Email obligatorio',
            '* El email debe ser válido'
        ],
        messageRules: [
            '* Mensaje obligatorio',
            '* La longitud mínima del mensaje es de 12 caracteres'
        ]
    }
};

export default {
    components: {
        ProvinceSchoolComponent
    },
    data: () => ({
        loading: false,
        snackbar: false,
        snackbarType: '',
        snackbarText: '',
        formRules: [
            v => !!v || trans[window.appLocale].formRules
        ],
        phoneRules: [
            v => !!v || trans[window.appLocale].phoneRules[0],
            v=> /^\d{9}$/.test(v) || trans[window.appLocale].phoneRules[1],
        ],
        emailRules: [
            v => !!v || trans[window.appLocale].emailRules[0],
             v => /.+@.+\..+/.test(v) || trans[window.appLocale].emailRules[1],
        ],
        messageRules: [
             v => !!v || trans[window.appLocale].messageRules[0],
            v => (v || '').length >= 12 ||
                trans[window.appLocale].messageRules[1],
        ],
        trans
    }),
    computed: {
        ...mapGetters(['getFormData']),
        validForm: {
            get(){
                return this.$store.getters.validForm;
            },
            set(value){
                this.setValidForm(value);
            }
        },
        name: {
            get(){
                return this.$store.getters.getFormData.name;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'name',
                    value: payload
                })
            }
        },
        email: {
            get(){
                return this.$store.getters.getFormData.email;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'email',
                    value: payload
                })
            }
        },
        phone: {
            get(){
                return this.$store.getters.getFormData.phone;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'phone',
                    value: payload
                })
            }
        },
        text: {
            get(){
                return this.$store.getters.getFormData.text;
            },
            set(payload){
                this.setParamFromFormData({
                    param: 'text',
                    value: payload
                })
            }
        },
    },
    methods: {
        ...mapMutations(['setParamFromFormData','setValidForm']),
        validateAndSend(e){
            e.preventDefault();

            if (!this.$refs.form.validate()) {
                this.showSnackbar('info', trans[this.lang].pleaseRecheck);
                return
            }
            this.loading = true;

            axios.post('/api/contact', {
                name: this.getFormData.name,
                phone: this.getFormData.phone,
                email: this.getFormData.email,
                message: this.getFormData.text,
                province: this.getFormData.province,
                school: this.getFormData.school,
            }).then((res) => {
                console.log(res);
                this.loading= false;
                this.showSnackbar('success', trans[this.lang].sent);
                this.$refs.form.reset();
            }).catch(err => {
                console.log(err);
                this.loading = false;
                this.showSnackbar('info', trans[this.lang].error);
            });
        },
        showSnackbar(snackbarType, snackbarText) {
            this.snackbarType = snackbarType;
            this.snackbarText = snackbarText;
            this.snackbar = true;
        }
    },
    created() {
        this.lang = window.appLocale;
    }
}
</script>

<style lang="scss">
.v-input{
    &__slot{
        background-color: rgba(255, 255, 255, 0.23) !important;
    }
}
.contactButton{
    padding: 0 30px !important;
    text-transform: capitalize;
    font-size: 16px !important;
    font-stretch: 100%;
    height: 45px !important;

}
input:-internal-autofill-selected {
    -webkit-appearance: menulist-button;
    background-color: transparent !important;
    background-image: none !important;
    color: -internal-light-dark-color(black, white) !important;
}
</style>
